import { yupResolver } from '@hookform/resolvers/yup';
import {
  Box,
  Button,
  DialogActions,
  makeStyles,
  Theme,
  useMediaQuery,
} from '@material-ui/core';
import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import ReactQuill from 'react-quill';
import * as yup from 'yup';

import { Modal } from '../../../../shared/components/Modal';
import { useSnackMessages } from '../../../../shared/hooks/useSnackMessages';
import { api } from '../../../../shared/services/apiClient';
import { Fofa } from '../../pages/Fofa/types';

import 'react-quill/dist/quill.snow.css';

interface EditFofaModalProps {
  data: Fofa;
  isOpen: boolean;
  onClose: () => void;
}

export function EditFofaModal({ isOpen, onClose, data }: EditFofaModalProps) {
  const useStyles = makeStyles((theme: Theme) => ({
    box: {
      width: '100%',
      [theme.breakpoints.down(861)]: {
        maxWidth: '100px',
      },
      [theme.breakpoints.down(828)]: {
        maxWidth: '100px',
      },
      [theme.breakpoints.down(647)]: {
        maxWidth: '100px',
      },
      [theme.breakpoints.down(513)]: {
        maxWidth: '100px',
      },
      [theme.breakpoints.down(440)]: {
        maxWidth: '100px',
      },
      [theme.breakpoints.down(387)]: {
        maxWidth: '100px',
      },
    },
  }));
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const { msgSuccess, msgError } = useSnackMessages();
  const isNotMobile = useMediaQuery('(min-width:600px)');
  const [strengths, setStrengths] = useState(data?.strengths);
  const [weaknesses, setWeaknesses] = useState(data?.weaknesses);
  const [opportunities, setOpportunitiess] = useState(data.opportunities);
  const [threats, setThreats] = useState(data?.threats);
  const schema = yup.object().shape({
    strengths: yup.string(),
    weaknesses: yup.string(),
    opportunities: yup.string(),
    threats: yup.string(),
  });

  const onSubmit = useCallback(async () => {
    setLoading(true);

    try {
      const formatData = {
        strengths,
        weaknesses,
        opportunities,
        threats,
      };

      await api.put(`/fofa/${data.id}`, formatData);

      msgSuccess('Fofa editado com sucesso!');
      onClose();
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      msgError(err?.response?.data?.message);
    }
  }, [
    msgError,
    strengths,
    weaknesses,
    opportunities,
    threats,
    msgSuccess,
    onClose,
    data.id,
  ]);
  const { handleSubmit } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: {
      strengthts: data?.strengths,
      weaknesses: data.weaknesses,
      opportunities: data.opportunities,
      threats: data.threats,
    },
    mode: 'onChange',
  });

  return (
    <Modal title="Editar FOFA" open={isOpen} onClose={onClose}>
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          gridGap={16}
          style={{ padding: '10px' }}
        >
          <fieldset
            style={{
              borderRadius: '4px',
              backgroundColor: '#E5FFD1',
              borderColor: '#C8EBAD',
            }}
          >
            <legend style={{ marginBottom: '10px' }}>Forças:</legend>
            <ReactQuill
              theme="snow"
              value={strengths}
              onChange={setStrengths}
              style={{
                minHeight: '100px',
                backgroundColor: 'none',
                marginLeft: '10px',
                marginRight: '10px',
              }}
            />
          </fieldset>
          <fieldset
            style={{
              borderRadius: '4px',
              backgroundColor: '#FFF2D1',
              borderColor: '#EBD9AD',
              // maxHeight: '300px',
            }}
          >
            <legend style={{ marginBottom: '10px' }}>Fraquezas:</legend>
            <ReactQuill
              theme="snow"
              value={weaknesses}
              onChange={setWeaknesses}
              style={{
                minHeight: '100px',
                backgroundColor: 'none',
                marginLeft: '10px',
                marginRight: '10px',
              }}
            />
          </fieldset>
          <fieldset
            style={{
              borderRadius: '4px',
              backgroundColor: '#D1F7FF',
              borderColor: '#ADE0EB',
            }}
          >
            <legend style={{ marginBottom: '10px' }}>Oportunidades:</legend>
            <ReactQuill
              theme="snow"
              value={opportunities}
              onChange={setOpportunitiess}
              style={{
                backgroundColor: 'none',
                marginLeft: '10px',
                marginRight: '10px',
              }}
            />
          </fieldset>
          <fieldset
            style={{
              borderRadius: '4px',
              backgroundColor: '#FFD1D1',
              borderColor: '#EBADAD',
            }}
          >
            <legend style={{ marginBottom: '10px' }}>Ameaças:</legend>
            <ReactQuill
              theme="snow"
              value={threats}
              onChange={setThreats}
              className={classes.box}
              style={{
                backgroundColor: 'none',
                marginLeft: '10px',
                marginRight: '10px',
              }}
            />
          </fieldset>

          <DialogActions>
            <Box
              display="flex"
              flexDirection="row"
              width="100%"
              gridGap={8}
              mt={4}
              justifyContent="flex-end"
              alignItems="center"
            >
              <Button
                autoFocus
                color="primary"
                variant="outlined"
                size="large"
                onClick={onClose}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                autoFocus
                size="large"
                color="primary"
                variant="contained"
                disabled={loading}
              >
                Salvar {isNotMobile && 'alterações'}
              </Button>
            </Box>
          </DialogActions>
        </Box>
      </Box>
    </Modal>
  );
}
